import { exportStageCopy, type ExportProgress } from '../../lib/export-progress';

export function ExportProgressToast({ progress, error, onDismiss, operation = 'export', unconfirmed = false }: {
  progress: ExportProgress | null;
  error?: string;
  onDismiss: () => void;
  operation?: 'export' | 'save';
  unconfirmed?: boolean;
}) {
  if (!progress && !error) return null;
  return <aside role={error && !unconfirmed ? 'alert' : 'status'} aria-live={error && !unconfirmed ? 'assertive' : 'polite'} aria-atomic="true"
    className="fixed bottom-5 right-5 z-[70] w-96 max-w-[calc(100vw-2.5rem)] rounded-xl border border-border bg-card p-5 text-foreground shadow-xl">
    <div className="flex items-start gap-3">
      {!error && <span aria-hidden="true" className="mt-1 h-5 w-5 shrink-0 rounded-full border-2 border-primary/25 border-t-primary motion-safe:animate-spin" />}
      <div className="min-w-0 flex-1">
        <h2 className="text-sm font-semibold">{operation === 'save' ? (unconfirmed ? 'Save not yet confirmed' : error ? 'Deck couldn’t be saved' : 'Saving to your Library') : (error ? 'Export couldn’t finish' : 'Preparing your .apkg download')}</h2>
        <p className="mt-2 text-sm leading-5 text-muted">{error || (operation === 'save' ? 'Saving your cards and images…' : progress && exportStageCopy[progress.stage])}</p>
        {!error && progress?.cardCount !== undefined && <p className="mt-2 text-xs font-medium text-muted">{progress.cardCount} card{progress.cardCount === 1 ? '' : 's'}</p>}
        {!error && <p className="mt-3 text-xs leading-5 text-muted">{operation === 'save' ? 'Keep this tab open until your deck is saved.' : 'Keep this tab open until your download starts. You can keep reviewing.'}</p>}
      </div>
      {error && <button type="button" onClick={onDismiss} aria-label={operation === 'save' ? 'Dismiss save error' : 'Dismiss export error'} className="px-1 text-muted">×</button>}
    </div>
  </aside>;
}
